import { useEffect, useState } from "react";
import { Inbox } from "lucide-react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export default function AdminContacts() {
  const [contacts, setContacts] = useState(null);

  useEffect(() => {
    api.get("/admin/contacts").then((r) => setContacts(r.data)).catch(() => setContacts([]));
  }, []);

  if (!contacts) return <Skeleton className="h-64 bg-white/5" />;

  return (
    <div className="space-y-6" data-testid="admin-contacts-page">
      <div>
        <p className="section-label">Enquiries</p>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-white tracking-tight mt-1">Contact Submissions</h2>
      </div>

      {contacts.length === 0 ? (
        <div className="card-surface p-14 text-center">
          <Inbox className="w-10 h-10 mx-auto text-slate-600 mb-3" />
          <p className="text-slate-400">No enquiries yet. Submissions from the public contact form appear here.</p>
        </div>
      ) : (
        <div className="card-surface overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="contacts-table">
              <thead>
                <tr className="text-left text-[10px] tracking-widest text-slate-500 uppercase border-b border-white/5 bg-secondary/20">
                  <th className="px-5 py-3.5">Date</th><th className="px-5 py-3.5">Name</th>
                  <th className="px-5 py-3.5">Company</th><th className="px-5 py-3.5">Email</th>
                  <th className="px-5 py-3.5">Industry</th><th className="px-5 py-3.5">Campaign Type</th>
                  <th className="px-5 py-3.5">Locations</th><th className="px-5 py-3.5">Message</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5">
                {contacts.map((c) => (
                  <tr key={c.id} className="text-slate-300" data-testid={`contact-row-${c.id}`}>
                    <td className="px-5 py-3 font-mono text-xs whitespace-nowrap">{new Date(c.created_at).toLocaleDateString("en-ZA")}</td>
                    <td className="px-5 py-3 font-semibold text-white whitespace-nowrap">{c.first_name} {c.last_name}</td>
                    <td className="px-5 py-3 text-xs">{c.company}</td>
                    <td className="px-5 py-3 text-xs">{c.email}</td>
                    <td className="px-5 py-3 text-xs">{c.industry}</td>
                    <td className="px-5 py-3 text-xs">{c.campaign_type}</td>
                    <td className="px-5 py-3 text-xs">{c.num_locations}</td>
                    <td className="px-5 py-3 text-xs max-w-[240px] truncate" title={c.message}>{c.message}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
